import React from 'react'
import { BsTwitter, BsInstagram, BsLinkedin, BsGithub } from 'react-icons/bs'


const SocialMedia = () => {
  return (
    <div className="app__social">

      <a href='https://www.linkedin.com/in/naveed-naseer-3183831b1'>
        <div>
            <BsLinkedin />
        </div>
      </a>
      <a href='https://www.instagram.com/ozingz'>
        <div>
            <BsInstagram />
        </div>
      </a>
      <a href='https://github.com/naveednaseer'>
        <div>
            <BsGithub />
        </div>
      </a>

    </div>
  )
}

export default SocialMedia